<template>
  <div class="article wrapper">
    <!-- <div class="header">
      {{ detail.C_TITLE }}
    </div> -->
    <img class="img" v-if="ismeet=='1'" :src="websiteBanner" width="100%" />
    <div class="detail">
      <div class="detail-logo" v-if="detail.C_LOGO">
        <img :src="detail.C_LOGO" />
      </div>
      <div class="detail-title">
        <!-- {{ detail.C_TITLE }} -->
      </div>
      <div class="detail-txt">
        <div class="date" v-if="detail.N_UserDef1">
          <van-icon name="clock-o" />
          <div>{{ detail.N_UserDef1 }}</div>
        </div>
        <!-- <div class="time" v-if="detail.N_UserDef1">{{ detail.N_UserDef1 }}</div> -->
      </div>
      <div class="detail-txt">
        <van-icon name="location-o" />
        <div>{{ detail.N_UserDef2 }}</div>
      </div>
      <div class="detail-content" v-html="detail.C_ABSTRACT"></div>
      <div class="detail-content" v-html="detail.C_CONTENT"></div>
    </div>
    <footerAct></footerAct>
  </div>
</template>
<script>
import { GetArticleById } from "@/api/index";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      content: "",
      id: "",
      title: "",
      detail: {},
      ismeet: 0,
    };
  },
  computed: {
    ...mapGetters(["webSiteImageUrl", "websiteBanner"]),
  },
  components: {},
  created(e) {
    let params = this.$route.query;
    
    if (params) {
      this.id = params.id;
      if (params.title) {
        document.title = params.title;
      }
      if (params.bshow) {
        this.ismeet = params.bshow;
      }
      // document.title = this.title;
    }
    console.log(this.id);
    if (this.id) {
      this.getArticleById();
    }
  },
  methods: {
    getArticleById() {
      let $this = this;
      GetArticleById($this.id)
        .then((res) => {
          if (res.article && res.article["C_LOGO"]) {
            res.article["C_LOGO"] =
              $this.webSiteImageUrl + res.article["C_LOGO"];
          }
          $this.detail = res.article;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  padding: 15px;
}
.detail-logo {
  img {
    width: 100%;
  }
}
.detail-title {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px;
}
.detail-content {
  padding: 15px 0px;
  white-space: pre-wrap;
  font-size: 14px;
  color: $theme-content-color;
  overflow: hidden;
  /deep/ img {
    width: 100%;
  }
}

.detail-txt {
  display: flex;
  align-items: center;
  font-size: 14px;
  .van-icon {
    margin-right: 5px;
  }
  .date {
    display: flex;
    align-items: center;
    .van-icon {
      margin-right: 5px;
    }
  }
  .time {
    margin-left: 20px;
  }
}
.article {
  // background: #fff;
  color: #fff;
  min-height: 100%;
}
</style>